import { render, staticRenderFns } from "./minimum-advertised-price-policy.vue?vue&type=template&id=1875cda4"
import script from "./minimum-advertised-price-policy.vue?vue&type=script&lang=js"
export * from "./minimum-advertised-price-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports